import React from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'language/i18n';
import Breadcrumb from 'components/Breadcrumb';
import Layout from 'components/partials/Layout';
import machineCategories from 'constants/machineCategories.json';
import CategoryItem from '../components/CategoryItem';

const Categories = ({ t }) => {
  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: t('categories'),
      url: '/brands/categories',
    },
  ];

  return (
    <main className="has-header">
      <div className="container">
        <div className="row mt-4 mb-4 mt-lg-3 mb-lg-3">
          <div className="col">
            <Breadcrumb links={breadcrumbs} />
          </div>
        </div>
        <div className="row">
          <div className="col-15 mt-3 mt-md-0">
            <div className="row mb-20">
              <div className="col">
                <h1 className="h1 text-center">Tüm İkinci El İş Makinası Kategorileri</h1>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <div className="row">
                  {machineCategories.map((category) => (
                    <CategoryItem key={category.id} category={category} />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

Categories.propTypes = {
  t: PropTypes.func,
};

export const getServerSideProps = async ({ req }) => {
  const { t } = req;

  return {
    props: {
      blackHeader: true,
      headTitle: t('categories'),
    },
  };
};

Categories.Layout = Layout;

export default withTranslation('common')(Categories);
